import { render, staticRenderFns } from "./partnerShipsDetail.vue?vue&type=template&id=7d619348&scoped=true"
import script from "./partnerShipsDetail.vue?vue&type=script&lang=js"
export * from "./partnerShipsDetail.vue?vue&type=script&lang=js"
import style0 from "./partnerShipsDetail.vue?vue&type=style&index=0&id=7d619348&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d619348",
  null
  
)

export default component.exports